export enum RawMaterialUnit {
  KG = "kg",
  GRAM = "g",
  LITER = "L",
  MILLILITER = "ml",
  PIECES = "pcs",
  PACKET = "packet",
  BOTTLE = "bottle",
  BOX = "box",
}

export const RAW_MATERIAL_UNIT_LABELS: Record<RawMaterialUnit, string> = {
  [RawMaterialUnit.KG]: "Kilogram (kg)",
  [RawMaterialUnit.GRAM]: "Gram (g)",
  [RawMaterialUnit.LITER]: "Liter (L)",
  [RawMaterialUnit.MILLILITER]: "Milliliter (ml)",
  [RawMaterialUnit.PIECES]: "Pieces (pcs)",
  [RawMaterialUnit.PACKET]: "Packet",
  [RawMaterialUnit.BOTTLE]: "Bottle",
  [RawMaterialUnit.BOX]: "Box",
};
